import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import { LoadingIndicator } from '@sorare/core/src/atoms/loader/LoadingIndicator';

import { MySquadOnboarding } from 'components/rivals/squads/MySquadOnboarding';

const MySquadLayout = () => {
  return (
    <Suspense fallback={<LoadingIndicator fullHeight />}>
      <MySquadOnboarding />
      <Outlet />
    </Suspense>
  );
};
export default MySquadLayout;
